exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.itemEven[data-v-4eaa402a] {\n  background-color: #ffffcc\n}\n.registration-form[data-v-4eaa402a] {\n  margin: auto;\n  text-align: left;\n  border-collapse: separate;\n  border-spacing: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4eaa402a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ManagementPage/UserRegistrationForm.vue
// module id = 512
// module chunks = 0